export default __webpack_public_path__ + "static/media/cholet8.1218bc02.jpg";